<ngx-spinner type="ball-spin-clockwise" bdColor="rgb(249, 249, 251)" size="medium" color="#ef870a" [fullScreen]="false" style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 9999;"></ngx-spinner>
        
<div id="layoutHome">
    <div>
        <div class="d-flex align-items-center w-100 mb-2" style="flex-direction: column;">
            <div class="mt-4 align-items-center justify-content-center w-100 text-center">
                <span class="fm-prompt weight-500" style="font-size: 1.429rem;color: #0F0F1F;">Select your {{ order?.meals_per_day && order?.days_per_week ? (order.meals_per_day * order.days_per_week) : '' }} Meals</span>
            </div>
            
            <app-meals-search-bar
                [isMobile]="isMobile"
                [meals]="allWeekMeals"
                (selectedTagChange)="onMealsSearchChange($event)"
                (selectedCategoryChange)="onMealsSearchChange($event)"
                (searchChange)="onMealsSearchChange($event)"
                (searchReset)="resetSearch()">
            </app-meals-search-bar>

        </div>
    </div>
    <div class="web-center">
        <div class="w-100 row mt-4 row mb-5 pb-3 mx-auto" *ngIf="visualWeekMeals.length>0" 
            [style]="!isMobile ? 'max-width: 1020px;' : (AddedMealsWeek.length > 0 && mealPopUpVisibility === false ? 'width: 100%; padding-bottom: 120px;' :'width: 100%;')">

            <app-new-meal-card
                *ngFor="let meal of visualWeekMeals"
                [meal]="meal"
                (addMeal)="addMeal($event)"
                (decreaseQuantity)="decreaseCount($event)"
                (increaseQuantity)="increaseCount($event)"
                (removeMeal)="removeMeal($event)">
            </app-new-meal-card>


        </div>
        <div *ngIf="visualWeekMeals.length==0 && !loading" class="d-flex flex-direction-column align-items-center" style="margin-top: 10%;">
            <span class="mb-4 mt-5">No meals found</span>
            <button class="btn btn-primary btn-add-to-cart weight-500 fm-prompt mb-4" (click)="resetSearch()">Clear search</button>
        </div>
    </div>
</div>
<div class="footer-custom-addons" *ngIf="mealsModel.length>0">
    <div style="padding-top: 1rem; padding-bottom: 1rem; width: 100%; max-width: 1420px; margin: 0 auto">
        <div *ngIf="isMobile" style="margin-bottom: 10px !important; display: flex; justify-content: center;">
            <span style="font-style: italic;" *ngIf="diff_meals>0">Select {{diff_meals}} more</span>
        </div>
        <div class="fm-rubik justify-content-center" style="align-items: center; font-size: 1.143rem;" [ngClass]="isMobile && selectedMealsTrigger ? '' : 'd-flex'">
            <div [ngClass]="isDesktop ? 'd-flex' : ''" [style]="!isMobile ? 'margin-left: 40px;' : ''">
                <div class="mx-auto web-left">
                    <div class="mb-2" [style]="!isMobile ? 'display: flex; align-items: baseline' : 'display: flex; align-items: center; justify-content: center;'">
                        <span class="t-black" [style]="!isMobile ? 'font-size: 3.357rem;' : 'font-size: 20px;'" >{{getTotalElementsWeek()}}</span>&nbsp;
                        <div class="d-flex">
                            <span class="weight-400 t-black"> meals selected</span>
                            <i class="pi mx-1 fs08" style="cursor: pointer;font-size: 1.5rem;"
                                (click)="showCheckoutDetails('selectedMeals')"
                                [ngClass]="selectedMealsTrigger ? 'pi-angle-up' : 'pi-angle-down'">
                            </i>
                        </div>
                    </div>
                    <div *ngIf="selectedMealsTrigger">
                        <div *ngFor="let item of AddedMealsWeek" class="mb-1" [style]="isMobile ? 'margin-left: 10px; width: 90%' : ''">
                            <span style="cursor: pointer;" (click)="removeMeal(item)" class="remove-meal">
                                <i class="pi pi-times mx-1 fs08"></i>
                            </span>&nbsp;
                            <span style="margin-right: 1rem;font-style: italic;">{{item.name}}</span>
                            <span class="fm-rubik weight-500" style="float: right;">×{{item.count}}</span>
                        </div>
                       
                    </div>
                </div>
            </div>
            <div class="mx-auto" *ngIf="!isMobile && !loading">
                <span style="font-style: italic;" *ngIf="diff_meals>0">Select {{diff_meals}} more</span>
                <span style="font-style: italic;" *ngIf="diff_meals==0">All selected</span>
                <div style="display: flex; flex-direction: row; flex-wrap: wrap; align-items: center; justify-content: center;" *ngIf="order?.meals_per_day && order?.days_per_week && (order.meals_per_day * order.days_per_week <= 10)">
                    <i class="pi circleIcon m-1 pi-circle-fill mt-2" style="font-size: 0.5rem;"
                        *ngFor="let num of tot_meals_array"></i>
                    <i class="pi circleIcon m-1 pi-circle mt-2" style="font-size: 0.5rem; color: #9595a1;"
                        *ngFor="let num of diff_meals_array"></i>
                </div>
                <div style="display: flex; flex-direction: row; flex-wrap: wrap; align-items: center; justify-content: center; width: 40%;" *ngIf="order?.meals_per_day && order?.days_per_week && (order.meals_per_day * order.days_per_week > 10) && (order.meals_per_day * order.days_per_week < 15)">
                    <i class="pi circleIcon m-1 pi-circle-fill mt-2" style="font-size: 0.5rem; width: 5.0%;"
                        *ngFor="let num of tot_meals_array"></i>
                    <i class="pi circleIcon m-1 pi-circle mt-2" style="font-size: 0.5rem; color: #9595a1; width: 5.0%;"
                        *ngFor="let num of diff_meals_array"></i>
                </div>
                <div style="display: flex; flex-direction: row; flex-wrap: wrap; align-items: center; justify-content: center; width: 45%;" *ngIf="order?.meals_per_day && order?.days_per_week && (order.meals_per_day * order.days_per_week >= 15) && (order.meals_per_day * order.days_per_week < 24)">
                    <i class="pi circleIcon m-1 pi-circle-fill mt-2" style="font-size: 0.5rem; width: 5.0%;"
                        *ngFor="let num of tot_meals_array"></i>
                    <i class="pi circleIcon m-1 pi-circle mt-2" style="font-size: 0.5rem; color: #9595a1; width: 5.0%;"
                        *ngFor="let num of diff_meals_array"></i>
                </div>
                <div style="display: flex; flex-direction: row; flex-wrap: wrap; align-items: center; justify-content: center; width: 30%;" *ngIf="order?.meals_per_day && order?.days_per_week && (order.meals_per_day * order.days_per_week == 24)">
                    <i class="pi circleIcon m-1 pi-circle-fill mt-2" style="font-size: 0.5rem; width: 5.0%;"
                        *ngFor="let num of tot_meals_array"></i>
                    <i class="pi circleIcon m-1 pi-circle mt-2" style="font-size: 0.5rem; color: #9595a1; width: 5.0%;"
                        *ngFor="let num of diff_meals_array"></i>
                </div>
            </div>
            <div class="mx-auto">
                <p-checkbox [(ngModel)]="selectedAllWeeks" [binary]="true" styleClass="rounded-checkbox"></p-checkbox>
                <span style="margin-left:5px">Apply to all remaining weeks</span>
            </div>
            <div *ngIf="!isMobile && !loading">
                <button class="btn btn-primary weight-500 getStartButton fm-prompt-button" style="margin-right: 40px;" (click)="updateOrderDetails()"
                    [disabled]="getTotalElements() < ((order?.meals_per_day && order?.days_per_week) ? (order.meals_per_day * order.days_per_week) : 0)">
                    <span>Confirm</span>
                    <i class="pi pi-arrow-right text-white arrow-icon"></i>
                </button>
            </div>
        </div>
        <div class="d-flex justify-content-center" *ngIf="isMobile">
            <button class="btn btn-primary weight-500 getStartButton fm-prompt-button" (click)="updateOrderDetails()"
                *ngIf="getTotalElements() == ((order?.meals_per_day && order?.days_per_week) ? (order.meals_per_day * order.days_per_week) : 0)">
                <span>Save and confirm</span>
                <i class="pi pi-arrow-right text-white arrow-icon"></i>
            </button>
        </div>
    </div>
</div>


<p-dialog
        [draggable]="false"
        [resizable]="false"
        [closable]="false"
        header="Header"
        [blockScroll]="true"
        [(visible)]="donePopupVisibility"
        [style]="{ width: dialogWidth }"
        [styleClass]="!isMobile ? 'custom-dialog-addons' : 'custom-dialog-mobile-addons'"
        (onHide)="closeConfirm()">
    <ng-template pTemplate="header">
        <div class="mt-4 align-items-center justify-content-center w-100 text-center">
            <img src="assets/images/task-done.png" style="width: 43px;height: 43px;" alt="">
            <br>
            <br>
            <span class="fm-prompt weight-500" style="font-size: 1.429rem;color: #0F0F1F;">Done!</span>
        </div>
    </ng-template>
    <div class="mt-1 p-2 text-center">
        <span style="font-size: 14px; font-weight: 400;">
            You successfully changed your meals.
        </span>
    </div>
    <div class="mt-4 p-2 d-flex" style="text-align: center; flex-direction: column; align-items: center;">
        <button class="btn btn-orange-animation fm-prompt weight-500 mb-3" (click)="closeConfirm()"
                style="color: white;background-color: #EF870A;font-size: 1.143rem;border-radius: 12px;padding-top: 0.5rem;padding-bottom: 0.5rem;width: 40%;">
            Go to my profile
        </button>
    </div>
</p-dialog>